import { render, staticRenderFns } from "./VidaUtilModelosPage.vue?vue&type=template&id=06cc73c4&scoped=true"
import script from "./VidaUtilModelosPage.vue?vue&type=script&lang=js"
export * from "./VidaUtilModelosPage.vue?vue&type=script&lang=js"
import style0 from "./VidaUtilModelosPage.vue?vue&type=style&index=0&id=06cc73c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc73c4",
  null
  
)

export default component.exports